import React, { useState, Fragment } from 'react';
import { Resizable } from 're-resizable';

import AccountSharing from '../AccountSharing';
import SidebarBookmarkContainer from './SidebarBookmarkContainer';
import SidebarCategoriesContainer from './SidebarCategoriesContainer';
import SidebarHeader from './SidebarHeader';
import SidebarLinks from './SidebarLinks';

import DocumentImportModal from '../../common/ImportDocumentModal';
import AddSlackQAChannelsModal from '../integrations/AddSlackQAChannelsModal';

import { getApiUserPreferenceUrl } from '../../utilities/urlHelper';

// App setup. Need this throughout app
import '../../common/getReferenceableUsersAndNotify';
import '../../common/getUserTodoCountAndNotify';

import '../create/CreateQuestionListener';
import '../create/CreateCategoryListener';

// Load lazily only when the Kai dashboard is present
if (window.location.pathname.includes('/kai-dashboard')) {
    import('../kai/ExcludedCategoriesListener');
}

const MIN_SIDEBAR_WIDTH = 250;
const MAX_SIDEBAR_WIDTH = 600;

const isValidWidth = (width) => width && Number.isInteger(width) && (width >= MIN_SIDEBAR_WIDTH) && (width <= MAX_SIDEBAR_WIDTH);

const MainSidebar = (props) => {
    const sidebarContainer = document.querySelector('#main-sidebar-container');
    const initialSize = parseInt(window.getComputedStyle(sidebarContainer).width);
    const [width, setWidth] = useState(initialSize || 300);
    const [isScrolled, setIsScrolled] = useState(false);
    const scrollableClass = isScrolled ? 'is-scrolled' : '';
    sidebarContainer.style.width = '';

    const saveWidth = (d) => {
        const sidebar_width = Math.round(width + d.width);
        if (!isValidWidth(sidebar_width)) return;

        fetch(getApiUserPreferenceUrl(), {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ sidebar_width }),
        }).catch(console.error);

        setWidth(sidebar_width);
    };

    const handleScroll = ({ target }) => {
        if (target.scrollTop > 0) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    };

    return (
        <Fragment>
            <Resizable
                style={{}}
                size={{ width, height: '100%' }}
                minWidth={MIN_SIDEBAR_WIDTH}
                maxWidth={MAX_SIDEBAR_WIDTH}
                minHeight="100%"
                maxHeight="100%"
                onResizeStop={(e, direction, ref, d) => saveWidth(d)}
                className="left-nav-resizer"
                enable={{
                    right: window.loggedIn,
                    top: false,
                    bottom: false,
                    left: false,
                    topRight: false,
                    bottomRight: false,
                    bottomLeft: false,
                    topLeft: false,
                }}
            >
                <AccountSharing />
                <SidebarHeader />
                <div className={`flex-auto flex flex-column scrollable-column ${scrollableClass}`} onScroll={handleScroll}>
                    <SidebarLinks />
                    <SidebarBookmarkContainer />
                    <SidebarCategoriesContainer />
                </div>
            </Resizable>
            <DocumentImportModal />
            <AddSlackQAChannelsModal />
        </Fragment>
    );
};

export default MainSidebar;
